import { NavLink } from 'react-router-dom';
import CustomGrid from '../components/CustomGrid.js';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import api from '../api/axiosConfig';
import { Box, Typography, CircularProgress, Checkbox } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ko } from 'date-fns/locale';
import { format, parse } from 'date-fns';

const DateEditCell = (props) => {
  const { id, field, value, api } = props;

  // 문자열 'YYYY-MM-DD' → Date 객체 변환
  const dateValue = value
    ? parse(value, 'yyyy-MM-dd', new Date())
    : null;

  const handleChange = (newDate) => {
    const formatted = newDate ? format(newDate, 'yyyy-MM-dd') : '';
    api.setEditCellValue({ id, field, value: formatted });
    api.stopCellEditMode({ id, field });
  };

  return (
      <DatePicker
        selected={dateValue}
        onChange={handleChange}
        dateFormat="yyyy-MM-dd"
        locale={ko}
        placeholderText="날짜 선택"
        popperPlacement="bottom-start"
        popperProps={{ strategy: 'fixed' }}
        portalId="root"
        fixedHeight   // ✅ 항상 6주 고정 높이로 렌더링
        customInput={
          <input
            style={{
              width: '100%',
              border: 'none',
              outline: 'none',
              fontSize: '13px',
              textAlign: 'center',
              cursor: 'pointer',
              background: 'transparent',
              padding: 0,
            }}
          />
        }
      />
  );
};

// 컬럼정의
const initialColumns: GridColDef[] = [
  {
    field: 'rowNumber',
    headerName: 'NO',
    width: 60,
    sortable: false,
    filterable: false,

    renderCell: (params) => {
        const { page, pageSize } = params.api.state.pagination.paginationModel;
        const rowIds = params.api.getAllRowIds();
        const globalIndex = rowIds.indexOf(params.id);
        return globalIndex + 1;
    },
  },
  {
    field: 'FIELD_NAME',
    headerName: '현장명',
    flex: 2,
    editable: true,
    align: 'left',
    headerAlign: 'center',
    headerClassName: 'required-header-field',
  },
  {
    field: 'PROVIDE_AMOUNT',
    headerName: '계약공급가',
    type: 'number',
    flex: 0.8,
    editable: true,
    align: 'right',
    headerAlign: 'center',
  },
  {
    field: 'VAT',
    headerName: '계약부가세',
    type: 'number',
    flex: 0.8,
    editable: true,
    align: 'right',
    headerAlign: 'center',
  },
  {
    field: 'TOTAL_AMOUNT',
    headerName: '계약금액',
    type: 'number',
    flex: 0.8,
    align: 'right',
    headerAlign: 'center',
  },
  {
    field: 'MANAGER',
    headerName: '현장대리인',
    type: 'text',
    flex: 0.7,
    editable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'START_DATE',
    headerName: '공사시작일',
    flex: 0.7,
    editable: true,
    align: 'center',
    headerAlign: 'center',
    renderEditCell: (params) => <DateEditCell {...params} />,
  },
  {
    field: 'END_DATE',
    headerName: '공사종료일',
    flex: 0.7,
    editable: true,
    align: 'center',
    headerAlign: 'center',
    renderEditCell: (params) => <DateEditCell {...params} />,
  },
  {
      field: 'USE_YN',
      headerName: '기간별조회',
      flex: 0.7,
      editable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
          <Checkbox checked={params.value === 'Y'} disabled />
      ),
      renderEditCell: (params) => (
          <Checkbox
              checked={params.value === 'Y'}
              onChange={(e) => {
                  params.api.setEditCellValue({
                      id: params.id,
                      field: params.field,
                      value: e.target.checked ? 'Y' : 'N'
                  });
              }}
          />
      ),
  },
  {
      field: 'USE_YN2',
      headerName: '수금현황',
      flex: 0.7,
      editable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
          <Checkbox checked={params.value === 'Y'} disabled />
      ),
      renderEditCell: (params) => (
          <Checkbox
              checked={params.value === 'Y'}
              onChange={(e) => {
                  params.api.setEditCellValue({
                      id: params.id,
                      field: params.field,
                      value: e.target.checked ? 'Y' : 'N'
                  });
              }}
          />
      ),
  },
  {
    field: 'ISSUED_CNT',
    headerName: '발행횟수',
    type: 'number',
    flex: 0.5,
    align: 'right',
    headerAlign: 'center',
  },
    {
      field: 'CREATED_AT',
      headerName: '최종수정일',
      type: 'text',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
];

const areRowsEqual = (row1, row2) => {
  const keys1 = Object.keys(row1).filter(k => k !== 'id' && k !== 'isNew');
  const keys2 = Object.keys(row2).filter(k => k !== 'id' && k !== 'isNew');

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    // null, undefined, 문자열 등 비교
    if (String(row1[key]) !== String(row2[key])) {
      return false;
    }
  }
  return true;
};


function TestPage() {
  const [dataRows, setDataRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);

  const [dataColumns, setDataColumns] = useState(initialColumns);
  const [loading, setLoading] = useState(true);
  const [fieldId, setFieldId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]); //체크된행

  const getSelectedRowsData = useCallback(() => {
    return dataRows.filter(row => selectedRows.includes(row.id));
  }, [dataRows, selectedRows]);


  const handleFieldIdChange = useCallback((newId) => {
    setFieldId(newId);

  }, [setFieldId]);


  const searchList = useCallback(() => {
    setLoading(true);

    const params = new URLSearchParams();
    if (fieldId) {
      params.append('fieldId', fieldId);
    }

    api
      .get(`/api/field/?${params.toString()}`)
      .then(res => {
        const data = res.data || [];

        const transformedData = data.map(item => ({
          ...item,
          id: item.FIELD_ID,
          isNew: false,
        }));

        setDataRows(transformedData);
        setOriginalRows(transformedData);

        // setDataRows(data);
      })
      .catch(err => {
        console.error("데이터 로드 실패:", err);
        setDataRows([]); // 에러 발생 시 빈 배열로 초기화
      })
      .finally(() => {
        setLoading(false);
      });
  }, [fieldId]);

  useEffect(() => {
    searchList();
  }, [searchList]);


  // 행추가
  const onAddRow = useCallback(() => {
    const tempId = `new-row-${Date.now()}-${Math.random()}`;
    const newRow = {
      FIELD_ID: tempId,
      id: tempId,
      FIELD_NAME: '',
      USE_YN: 'Y',
      USE_YN2: 'Y',
      isNew: true,
    };

    setDataRows(prevRows => [newRow, ...prevRows]);

  }, []);

  //금액 변경
  const handleProcessRowUpdate = useCallback((newRow, oldRow) => {
    const provide = Number(newRow.PROVIDE_AMOUNT) || 0;

    // PROVIDE_AMOUNT가 변경된 경우 VAT 자동 계산
    const vat = newRow.PROVIDE_AMOUNT !== oldRow.PROVIDE_AMOUNT
      ? Math.round(provide * 0.1)   // 10% 자동계산
      : Number(newRow.VAT) || 0;    // 직접 수정한 경우 그대로 유지

    const updatedRow = {
      ...newRow,
      VAT: vat,
      TOTAL_AMOUNT: provide + vat,
    };

    setDataRows(prevRows =>
      prevRows.map(row =>
        row.id === updatedRow.id ? updatedRow : row
      )
    );

    return updatedRow;
  }, []);

  // 저장
  const onSave = useCallback(() => {

    if (!window.confirm('저장하시겠습니까?')) return;

    let sendData = {
      createdList: [],
      updatedList: []
    };


    for (const currentRow of dataRows) {
      // 현장명 입력 체크
      if (currentRow.FIELD_NAME === "" || currentRow.FIELD_NAME === undefined) {
        window.alert('현장명을 입력해주세요.')
        return false;
      }

      if (currentRow.isNew === true) {
        sendData.createdList.push(currentRow);
      } else {
        const originalRow = originalRows.find(
          r => r.FIELD_ID === currentRow.FIELD_ID
        );

        if (originalRow && !areRowsEqual(originalRow, currentRow)) {
          sendData.updatedList.push(currentRow);
        }
      }

    }

    if (sendData.createdList.length === 0 && sendData.updatedList.length === 0) {
      window.alert('변경사항이 없습니다.')
      return;
    }

    api
      .post(`/api/field/save`, sendData)
      .then(() => {
        alert('저장되었습니다.');
        searchList();
      })
      .catch(err => {
        alert('저장 중 오류가 발생했습니다. ' + (err.response?.data || err.message));
      });


  }, [dataRows, originalRows]);


  // 체크된 행 얻기
  const handleSelectionChange = useCallback((newSelectionModel) => {
    const idsSet = newSelectionModel?.ids;

    if (idsSet) {
      const newIdsArray = Array.from(idsSet);
      setSelectedRows(newIdsArray);
    } else {
      setSelectedRows(newSelectionModel);
    }
  }, []);

  // 삭제
  const onDelete = useCallback(() => {

    if (!window.confirm('삭제하시겠습니까?')) return;

    const rowsToDelete = dataRows.filter(row => selectedRows.includes(row.id));

    if (rowsToDelete.length === 0) {
      window.alert('삭제할 행을 선택해주세요.');
      return;
    }

    const dbDeleteList = rowsToDelete
      .filter(row => !row.isNew)
      .map(row => ({
        FIELD_ID: row.FIELD_ID
      }));

    const clientOnlyDeleteIds = rowsToDelete
      .filter(row => row.isNew)
      .map(row => row.id);

    if (dbDeleteList.length > 0) {
      api
        .post(`/api/field/delete`, dbDeleteList)
        .then(() => {
          alert('삭제되었습니다.');
          searchList();
          setSelectedRows([]);
        })
        .catch(err => {
          alert('삭제 중 오류가 발생했습니다. ' + (err.response?.data || err.message));
        });
    }

    if (clientOnlyDeleteIds.length > 0 || dbDeleteList.length === 0) {

      setDataRows(prevRows =>
        prevRows.filter(row =>
          !rowsToDelete.some(deletedRow => deletedRow.id === row.id)
        )
      );

      if (dbDeleteList.length === 0) {
        alert('삭제되었습니다.');
      }

      setSelectedRows([]); // 선택 상태 초기화
    }


  }, [searchList, dataRows, selectedRows]);

  // 신규 행 스타일 변경
  const getRowClassName = useCallback((params) => {
    if (params.row.isNew === true) {
      return 'new-row-highlight';
    }

    return '';
  }, []);


  return (
    <div >
      <CustomGrid
        dataRows={dataRows}
        dataColumns={dataColumns}
        addRowBtn={true}
        onAddRow={onAddRow}
        saveBtn={true}
        onSave={onSave}
        deleteBtn={true}
        onDelete={onDelete}
        onFieldSearch={true}
        getRowClassName={getRowClassName}
        processRowUpdate={handleProcessRowUpdate}
        onFieldIdChange={handleFieldIdChange}
        onSearch={searchList}

        onRowSelectionModelChange={handleSelectionChange}

        title="현장 등록"
      />

    </div>
  );
}

export default TestPage;